import React, { FC, useContext, useEffect } from 'react';
import { useCommon } from '../../../../../contexts/CommonContext';
import DailyEngagedUsersContext from '../../../../../contexts/DailyEngagedUsersContext';
import { useContentLocalizer } from '../../../../../hooks/useContentLocalizer';
import DailyEngagedUserUsage from '../../../DailyEngagedUsers/components/DailyEngagedUserUsage';
import { localizationDailyEngagedUsers } from '../../localization';
import { DailyEngagedUserContainer } from '../../styles';

const DailyUsageComponent: FC = () => {
  const { dateToSearch, tenant } = useContext(DailyEngagedUsersContext);
  const { setHeaderContent } = useCommon();
  const content = useContentLocalizer(localizationDailyEngagedUsers);

  useEffect(() => {
    setHeaderContent({
      redirect: '/deu-consumption',
      text: content.formatString(content.header, tenant.info.name),
    });

    return () => setHeaderContent({ redirect: null });
  }, [dateToSearch]);

  return (
    <DailyEngagedUserContainer>
      <DailyEngagedUserUsage isDetailedView />
    </DailyEngagedUserContainer>
  );
};

export default DailyUsageComponent;
